export default __webpack_public_path__ + "static/media/icon_flag_yellow.0f378400.svg";